import { AnimatePresence, LazyMotion, domAnimation } from "framer-motion"
import React from "react"

import { GreyChevron } from "../../../utils/IconsList"
import Img from "../../../utils/OptimizedImage"
import onKeyDown from "../../../utils/onKeyDown"
import { ItemContent, ItemWrapper } from "../styles/SlideBoxAccordion.styled"

const AccordionItem = ({
  index,
  navLabel,
  heading,
  subhead,
  image,
  handleClick,
  opened,
}) => {
  return (
    (navLabel || heading) && (
      <ItemWrapper className={`${opened[index] ? "opened" : ""}`}>
        <div
          className="item-heading"
          onClick={() => handleClick(index)}
          onKeyDown={(e) => onKeyDown(e, () => handleClick(index))}
          tabIndex={0}
          role="button"
          aria-expanded={opened[index]}
          aria-label={navLabel}
        >
          <span className="item-label">{navLabel || heading}</span>
          <GreyChevron />
        </div>
        <LazyMotion features={domAnimation}>
          <AnimatePresence>
            {opened[index] === true && (
              <ItemContent
                className="item-content"
                aria-hidden={!opened[index]}
                initial="collapsed"
                animate="open"
                exit="collapsed"
                variants={{
                  open: { opacity: 1, height: "auto" },
                  collapsed: { opacity: 0, height: 0 },
                }}
                transition={{ duration: 0.3 }}
              >
                {heading && <p className="item-content-heading">{heading}</p>}
                {subhead && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: subhead,
                    }}
                    className="slide-subhead"
                  />
                )}
                {image && (
                  <div className="image-wrapper">
                    <Img
                      image={image?.gatsbyImageData}
                      src={image?.url}
                      alt={image?.alt || heading}
                      fadeIn={false}
                      className="slideImg"
                      loading="eager"
                    />
                  </div>
                )}
              </ItemContent>
            )}
          </AnimatePresence>
        </LazyMotion>
      </ItemWrapper>
    )
  )
}

export default AccordionItem
